import objectToQueryParams from '../utils/objecttoqueryparams';
import { resolveMultiplesPromises } from '../utils/promises';

import request from './request';

export const fetchArticles = (queryObject) => {
  let queryParams = '';
  if (queryObject) {
    queryParams = objectToQueryParams(queryObject);
  }
  return request({
    method: 'GET',
    url: `/communication/press/search${queryParams}`,
    protectedRoute: true,
    newApi: true
  });
};

export const fetchArticlesHeader = () =>
  request({
    method: 'GET',
    url: '/communication/press/header',
    protectedRoute: true,
    newApi: true
  });

export const fetchArticle = (id) =>
  request({
    method: 'GET',
    url: `/communication/press/${id}/`,
    protectedRoute: true,
    newApi: true
  });

// Toggle Favorite ON/OFF for article
export const setFavorite = (id) =>
  request({
    method: 'PUT',
    url: `/communication/press/${id}/set_favorite`,
    protectedRoute: true,
    newApi: true
  });

// Toggle Favorite ON/OFF for article
export const setRead = (id) =>
  request({
    method: 'PUT',
    url: `/communication/press/${id}/set_read`,
    protectedRoute: true,
    newApi: true
  });

// Toggle Favorite ON for multiples articles
export const setMultipleFavorites = (data) =>
  request({
    method: 'PUT',
    url: '/communication/press/set_favorite_bulk',
    protectedRoute: true,
    data,
    newApi: true
  });

export const addTag = (id, data) =>
  request({
    method: 'POST',
    url: `/communication/press/${id}/add_tag`,
    data,
    protectedRoute: true,
    newApi: true
  });

export const removeTag = (id, data) =>
  request({
    method: 'POST',
    url: `/communication/press/${id}/remove_tag`,
    data,
    protectedRoute: true,
    newApi: true
  });

export const addMultipleTagsToArticles = (articlesIds, tags) =>
  articlesIds.map((id) => handleMultipleCalls(id, tags, addTag));

export const removeMultipleTagsFromArticles = (articlesIds, tags) =>
  articlesIds.map((id) => handleMultipleCalls(id, tags, removeTag));

function handleMultipleCalls(articleId, list, func) {
  const promises = [];
  list.forEach((elem) => promises.push(func(articleId, elem)));

  return resolveMultiplesPromises(promises);
}

export const downloadPostPdf = async (id) => {
  const response = await request({
    method: 'GET',
    url: `/communication/press/${id}/pdf`,
    protectedRoute: true,
    newApi: true,
    returnFullResponse: true
  });

  if (!response.status || response.status !== 200) {
    return;
  }

  const link = document.createElement('a');
  link.href = response.data.file_url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const share = (id, data) => {
  return request({
    method: 'POST',
    url: `/communication/press/${id}/share`,
    data,
    protectedRoute: true,
    newApi: true
  });
};

export const fetchArticlesFeed = () => {
  return request({
    method: 'GET',
    url: '/communication/press/feed?no_page',
    protectedRoute: true,
    newApi: true
  });
};

export const exportPostsAsZip = async ({ postsIds, languageTarget }) => {
  const response = await request({
    method: 'POST',
    url: '/communication/press/export/zip',
    protectedRoute: true,
    newApi: true,
    data: {
      posts_ids: postsIds,
      language_target: languageTarget
    },
    responseType: 'blob',
    returnFullResponse: true
  });

  if (!response) {
    return false;
  }

  const blob = new Blob([response.data], {
    type: 'application/zip'
  });

  let filename = 'archive.zip';
  if (response.headers['content-disposition']) {
    filename = response.headers['content-disposition']
      .split(`filename="`)[1]
      .split(`"`)[0];
  }
  return { blob, filename };
};

export const exportPostsAsXls = async ({ postsSearchFilter, postsIds }) => {
  const response = await request({
    method: 'POST',
    url: '/communication/press/export/xls',
    protectedRoute: true,
    newApi: true,
    data: {
      posts_ids: postsIds,
      posts_search_filter: postsSearchFilter
    },
    responseType: 'blob',
    returnFullResponse: true
  });

  if (!response) {
    return false;
  }

  const blob = new Blob([response.data], {
    type: 'application/vnd.ms-excel'
  });

  let filename = 'articles-export.xls';
  if (response.headers['content-disposition']) {
    filename = response.headers['content-disposition']
      .split(`filename="`)[1]
      .split(`"`)[0];
  }
  return { blob, filename };
};

export const downloadPostsAsPdf = async (
  { posts_ids, language_target },
  retry = 3
) => {
  if (retry === 0) {
    return;
  }
  const response = await request({
    method: 'POST',
    url: '/communication/press/export/pdf',
    data: { posts_ids, language_target },
    protectedRoute: true,
    newApi: true,
    returnFullResponse: true
  });
  if (response.status === 200) {
    const link = document.createElement('a');
    link.href = response.data.file_url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return;
  }
  // Retry 3 times while the response has error
  return downloadPostsAsPdf({ posts_ids, language_target }, retry - 1);
};
